var _style, _g, _rect, _rect2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTorresStraitFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415.6 294.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill: #3B56A6;\n\t\t}\n\t\t.st1 {\n\t\t\tfill: #008843;\n\t\t}\n\t\t.st2 {\n\t\t\tfill: #020403;\n\t\t}\n\t\t.st3 {\n\t\t\tfill: #FFFFFF;\n\t\t}\n\t\t.st4 {\n\t\t\tfill: #010101;\n\t\t}\n\t\t.st5 {\n\t\t\tfill: #DB2E33;\n\t\t}\n\t\t.st6 {\n\t\t\tfill: #FEDA00;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 415.6,
    height: 294.2,
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 0.2,
    y: 0.1,
    width: 415.4,
    height: 77.4,
    fill: "#080"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    y: 218.7,
    width: 415.6,
    height: 77,
    fill: "#080"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    y: 216.7,
    width: 415.6,
    height: 13.3,
    fill: "#020403"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    y: 64.2,
    width: 415.6,
    height: 13.3,
    fill: "#020403"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "207.3 151.9 197.4 159 201.2 147.4 191.3 140.3 203.5 140.3 207.3 128.7 211.1 140.3 223.3 140.3 213.4 147.4 217.2 159"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m267.7 120.7s-8-38.7-54.1-38.7l-5.7 19.9-5.7-19.9c-46.1 0-54.1 38.7-54.1 38.7-8.3 37.6 15.4 66.5 15.4 66.5l-15.4 26.3 40.2-25.2s0.7-31.1 0.7-47.2c0-14.9 16.2-15.4 18.7-15.4h0.2 0.2c2.5 0 18.7 0.5 18.7 15.4 0 16.1 0.7 47.2 0.7 47.2l40.2 25.2-15.4-26.3s23.7-28.9 15.4-66.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorresStraitFlag);
export default __webpack_public_path__ + "static/media/torres-strait-flag.52f55f4d2b1680c9cbe19b07b38935b0.svg";
export { ForwardRef as ReactComponent };